import { ReactElement } from "react";
import { NotificationMemberDetails } from "types";
import styles from "../alerts-notification/alerts-notification.module.css";
import { DisplayIcon } from "@justworkshr/milo-icons";

const { alertsNotification, hasAvatar, reconnectPlaidIcon } = styles;

export default function PlaidReconnect({
  message,
  url,
}: {
  message: string;
  url?: string;
  member?: NotificationMemberDetails;
}): ReactElement {
  return (
    <div className={`${alertsNotification} ${hasAvatar}`}>
      <DisplayIcon
        className={reconnectPlaidIcon}
        iconName={"caution-sign"}
        color={"red"}
      />
      <span>
        <a href={url}>{message}</a>
      </span>
    </div>
  );
}
